<template>
  <Dialog v-model:visible="store.visible" modal :closable="false" :style="{ width: '420px', maxWidth: '92vw' }" header="Confirm your password">
    <form @submit.prevent="handleConfirm">
      <div class="gateway-icon">
        <i class="fas fa-lock"></i>
      </div>

      <p class="text-dark text-center mb-4">Your session with the payment gateway has expired. Enter your password to continue. You won't need the verification code again on this device.</p>

      <div class="mb-3">
        <label class="form-label text-dark">Password</label>
        <Password v-model="password" :feedback="false" placeholder="Password" :style="{ width: '100%' }"
          :inputStyle="{ width: '100%' }" :class="{ 'p-invalid': error }" toggleMask fluid autofocus />
      </div>

      <div v-if="error" class="text-danger text-center mb-3">
        <i class="fas fa-exclamation-circle me-1"></i>{{ error }}
      </div>

      <div class="d-flex justify-content-between align-items-center mt-4">
        <button type="button" class="btn btn-link p-0" :disabled="loading" @click="handleCancel">Log out instead</button>
        <button type="submit" class="btn btn-brand-navy text-white fw-semibold px-4" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          {{ loading ? 'Confirming…' : 'Confirm' }}
        </button>
      </div>
    </form>
  </Dialog>
</template>

<script>
import { ref, watch } from 'vue'
import Password from 'primevue/password'
import { useGatewaySessionPromptStore } from '@/stores/gatewaySessionPrompt'
import http from '@/lib/http'

export default {
  name: 'GatewaySessionPromptModal',
  components: { Password },
  setup() {
    const store = useGatewaySessionPromptStore()
    const password = ref('')
    const error = ref('')
    const loading = ref(false)

    watch(() => store.visible, (visible) => {
      if (visible) {
        password.value = ''
        error.value = ''
      }
    })

    const handleConfirm = async () => {
      loading.value = true
      error.value = ''
      try {
        await http.post('/auth/refresh-gateway-session', { password: password.value })
        store.confirm()
      } catch (err) {
        error.value = err?.response?.data?.message || 'Incorrect password'
      } finally {
        loading.value = false
      }
    }

    const handleCancel = () => {
      store.cancel()
    }

    return { store, password, error, loading, handleConfirm, handleCancel }
  },
}
</script>

<style scoped>
.btn-brand-navy {
  background: linear-gradient(135deg, #243654 60%, #3a5a8c 100%);
  border: none;
  transition: filter 0.3s ease;
}

.btn-brand-navy:hover {
  filter: brightness(1.1);
}

.btn-brand-navy:disabled {
  opacity: 0.7;
}

.gateway-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin: 0 auto 1rem;
  border-radius: 50%;
  background-color: rgba(36, 54, 84, 0.1);
  color: #243654;
  font-size: 1.5rem;
}
</style>
